import React from 'react';

const SvgLyft = ({ title, ...props }) => (
  <svg
    id="lyft_svg__Lyft_Logo"
    x={0}
    y={0}
    viewBox="0 0 1410 1124"
    xmlSpace="preserve"
    fill="#ff00bf"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path
      className="lyft_svg__st0"
      d="M416 618V298H296v300c0 82.4 54.4 120 105 120 15.1 0 30.2-3.5 43.7-9.8 2-.9 5.2-2.9 5.2-2.9s-3-3.2-4.3-4.6C426.4 678.8 416 650.4 416 618zM1116 538V418h-42.8c-17.9-94.3-117-156.3-216.6-119C801.1 319.7 756 386 756 445.3v272.6h5.2c30.9-1.3 59.8-14.4 81.3-36.8 21.6-22.5 33.5-52 33.5-83.1h50V478h-50v-33c0-12.8 6.8-24.8 18-31 30.7-17.1 62 4.9 62 34v110c0 43.5 16.4 83.9 46.3 113.8 28.5 28.5 67.1 44.9 108.6 46.2h5.1V598c-22.4-.1-40-18.1-40-40v-20h40zM606 418v160c0 11-9 20-20 20s-20-9-20-20V418H446v200c0 55.1 44.9 100 100 100 23.8 0 46.9-8.5 65-24-1.9 14.8-10 27-23.6 35.5-12.7 8-29.3 12.2-47.9 12.2-19.2 0-38.7-4.5-56.4-13 0 0-3.2-1.5-7.2-3.8v106.6c26.7 10.8 56 16.5 84.3 16.5 44.8 0 85.7-14 115.2-39.5C708.5 780 726 738.3 726 688V418H606z"
    />
  </svg>
);

export default SvgLyft;
